module.exports = __WEBPACK_EXTERNAL_MODULE_38__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Popper","commonjs2":"popper.js","commonjs":"popper.js","amd":"popper.js","umd":"popper.js"}
// module id = 38
// module chunks = 0